import React from 'react'

import './index.css'

function display(props) {
   return <div className="display">{props.formula}</div>
}

export default display
